import React from 'react';
import useInView from '../Animation/useInView.ts';
import styles from './Card.module.css';

const Card = ({
  title,
  description,
  imageSrc,
  imageAlt = "Изображение услуги",
  className = "",
  imageOnLeft = true
}) => {
  const { ref, isInView } = useInView({ threshold: 0.1, triggerOnce: true });

  const finalImageOnLeft = (typeof window !== 'undefined' && window.innerWidth < 768) || imageOnLeft;


  const cardContent = finalImageOnLeft ? (
    <>
      <div className={styles.cardImageWrapper}>
        <img src={imageSrc} alt={imageAlt} className={styles.cardImage} loading="lazy" />
      </div>
      <div className={styles.cardText}>
        <h2 className={styles.cardTitle}>{title}</h2>
        <p className={styles.cardDescription}>{description}</p>
      </div>
    </>
  ) : (
    <>
      <div className={styles.cardText}>
        <h2 className={styles.cardTitle}>{title}</h2>
        <p className={styles.cardDescription}>{description}</p>
      </div>
      <div className={styles.cardImageWrapper}>
        <img src={imageSrc} alt={imageAlt} className={styles.cardImage} loading="lazy" />
      </div>
    </>
  );

  return (
    <div
      id='CardId'
      ref={ref}
      className={`${styles.card} ${className} ${isInView ? styles.visible : ''}`}
    >
      {cardContent}
    </div>
  );
};

export default Card;
